// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__68444","content":"LayoutSettings_content__1TRRK"};